import React from 'react';
import { Box } from '@chakra-ui/react';

const AdminListPageLayout: React.FC<{ children: React.ReactNode }> = ({
  children
}) => (
  <Box
    display="flex"
    flexDirection="column"
    flex="1 1 0"
    minHeight={0}
    height="100%"
    width="100%">
    {children}
  </Box>
);

AdminListPageLayout.displayName = 'AdminListPageLayout';
export { AdminListPageLayout };
